import React, { useEffect, useState } from "react";
import { useRootSelector } from "~redux/hooks";
import {
  EquipmentTemplateSelectOption,
  type EquipmentTemplateBodyProps,
} from "components/views/template/EquipmentTemplateMenu";
import { aselFlightplanSelector } from "~redux/slices/aircraftSlice";
import type { NavigationCode, RNAV2Code } from "@poscon/shared-types";
import { isNavigationCode, isRNAV2Code } from "@poscon/shared-types";
import { colorNameMap, Label, useInputProps } from "@poscon/shared-frontend";
import { edstFontDim } from "~/utils/constants";

const tint = colorNameMap.grey;

const navaidItems = ["F", "O", "D", "T"] as const;
type NavCat = (typeof navaidItems)[number];

const navCatText: Record<NavCat, string> = {
  F: "(ADF)",
  O: "(VOR)",
  D: "(DME)",
  T: "(TACAN)",
};

const rnavItems = ["G", "I", "C", "R", "X"] as const;
type RnavCat = (typeof rnavItems)[number];

const rnavCatText: Record<RnavCat, string> = {
  G: "(GPS/GNSS)",
  I: "(INS)",
  C: "(LORAN C)",
  R: "(PBN APPROVED)",
  X: "(MNPS APPROVED)",
};

export const EquipmentNavTemplate = ({ setReset, fp }: EquipmentTemplateBodyProps) => {

  const inputProps = useInputProps(
    `eqp/nav/input`,
    "",
    (s) => {
      // TODO: implement
    },
    {
      maxLength: 50,
      focusOnMount: false,
    }
  );

  const [navaidCategories, setNavaidCategories] = useState<NavigationCode[]>([]);
  const [rnavCategories, setRnavCategories] = useState<string[]>([]);

  const [rvsm, setRvsm] = useState<boolean>(false);

  const toggleCategory = (cat: NavCat | RnavCat) => {
    if (isNavigationCode(cat)) {
      const navCats = [...navaidCategories];
      const index = navCats.indexOf(cat);
      if (index < 0) {
        setNavaidCategories([...navCats, cat]);
      } else {
        navCats.splice(index, 1);
        setNavaidCategories(navCats);
      }
    }
    // } else if () {
    //   const rnavCats = [...rnavCategories];
    //   const index = rnavCats.indexOf(cat);
    //   if (index < 0) {
    //     setRnavCategories([...rnavCats, cat]);
    //   } else {
    //     rnavCats.splice(index, 1);
    //     setRnavCategories(rnavCats);
    //   }
    // }
  };

  useEffect(() => {
    // TODO: we need to include more codes here
    const field10a = fp?.navigationCodes ?? [];
    const navaidCats = field10a.filter(isNavigationCode);
    const initialRvsm = field10a.includes("W");

    const reset = () => {
      setNavaidCategories(navaidCats);
      // setRnavCategories(rnavCats);
      setRvsm(initialRvsm);
    };

    setReset(reset);
    reset();
  }, [fp?.navigationCodes, setReset]);

  return (
    <>
      <container x={10}>
        <Label text="NAVAIDS" x={edstFontDim.width * 2} tint={tint} />
        <container y={edstFontDim.height + 8}>
          {navaidItems.map((category, i) => (
            <EquipmentTemplateSelectOption
              key={category}
              y={(edstFontDim.height + 3) * i}
              text={`${category} ${navCatText[category]}`}
              variant="square"
              onmousedown={() => {
                toggleCategory(category);
              }}
              selected={navaidCategories.includes(category)}
            />
          ))}
        </container>
      </container>
      <container x={edstFontDim.width * 20}>
        <Label text="RNAV" x={edstFontDim.width * 4} tint={tint} />
        <container y={edstFontDim.height + 8}>
          {rnavItems.map((category, i) => (
            <EquipmentTemplateSelectOption
              key={i}
              y={(edstFontDim.height + 3) * i}
              text={`${category} ${rnavCatText[category]}`}
              variant="square"
              onmousedown={() => {
                toggleCategory(category);
              }}
              selected={rnavCategories.includes(category)}
            />
          ))}
        </container>
      </container>
      <container x={edstFontDim.width * 50}>
        <EquipmentTemplateSelectOption text="RNAV" variant="circle" onmousedown={() => {}} selected={false} />
        <EquipmentTemplateSelectOption
          x={edstFontDim.width * 8}
          text="RNP"
          variant="circle"
          onmousedown={() => {}}
          selected={false}
        />
        <container y={edstFontDim.width + 8}></container>
      </container>
      <container x={edstFontDim.width * 75}>
        <Label text="RVSM" x={Math.floor(edstFontDim.width * 3.5)} tint={tint} />
        <EquipmentTemplateSelectOption
          y={edstFontDim.height + 8}
          text="W (RVSM)"
          variant="square"
          onmousedown={() => setRvsm(!rvsm)}
          selected={rvsm}
        />
      </container>
    </>
  );
  // return (
  //   <>
  //     <div className={eqpStyles.titleRow}>
  //       <div className={eqpStyles.col}>
  //         <div className={eqpStyles.colTitle}>NAVAIDS</div>
  //         {Object.values(NavCat).map((category) => (
  //           <EquipmentTemplateRow
  //             key={category}
  //             buttonText={category}
  //             text={navCatText[category]}
  //             selected={navCategories.includes(category)}
  //             toggleSelect={() => toggleCategory(category)}
  //           />
  //         ))}
  //       </div>
  //       <div className={eqpStyles.col}>
  //         <div className={eqpStyles.colTitle}>RNAV</div>
  //         {Object.values(RnavCat).map((category) => (
  //           <EquipmentTemplateRow
  //             key={category}
  //             buttonText={category}
  //             text={rnavCatText[category]}
  //             selected={rnavCategories.includes(category)}
  //             toggleSelect={() => toggleCategory(category)}
  //           />
  //         ))}
  //       </div>
  //       <div className={eqpStyles.col}>
  //         <div className={eqpStyles.contentRow}>
  //           <div className={eqpStyles.contentCol}>
  //             <div className={optionStyles.circleIndicator} />
  //             RNAV
  //           </div>
  //           <div className={eqpStyles.contentCol}>
  //             <div className={optionStyles.circleIndicator} />
  //             RNP
  //           </div>
  //         </div>
  //         <div className={eqpStyles.contentRow}>
  //           <div className={eqpStyles.inputContainer}>
  //             <input />
  //           </div>
  //           D (DEPARTURE)
  //         </div>
  //         <div className={eqpStyles.contentRow}>
  //           <div className={eqpStyles.inputContainer}>
  //             <input />
  //           </div>
  //           E (EN ROUTE)
  //         </div>
  //         <div className={eqpStyles.contentRow}>
  //           <div className={eqpStyles.inputContainer}>
  //             <input />
  //           </div>
  //           A (ARRIVAL)
  //         </div>
  //         <div className={eqpStyles.contentRow}>
  //           <div className={eqpStyles.inputContainer}>
  //             <input />
  //           </div>
  //           G (GLOBAL/OCEAN)
  //         </div>
  //         <div className={eqpStyles.contentRow}>
  //           <div className={eqpStyles.inputContainer}>
  //             <input />
  //           </div>
  //           L (LANDING)
  //         </div>
  //         <div className={eqpStyles.contentRow}>
  //           <div className={eqpStyles.inputContainer}>
  //             <input />
  //           </div>
  //           S (SPECIAL)
  //         </div>
  //       </div>
  //       <div className={eqpStyles.col}>
  //         <div className={eqpStyles.colTitle}>RVSM</div>
  //         <EquipmentTemplateRow buttonText="W" text="(RVSM)" selected={rvsm} toggleSelect={() => setRvsm(!rvsm)} />
  //       </div>
  //     </div>
  //     <div className={eqpStyles.inputRow}>
  //       NAV/
  //       <div className={clsx(eqpStyles.inputContainer, eqpStyles.mw60)}>
  //         <input
  //           readOnly
  //           value={
  //             [...(navCategories as string[])]
  //               .concat([...(rnavCategories as string[])])
  //               .sort((u, v) => u.localeCompare(v))
  //               .join("") + (rvsm ? "W" : "")
  //           }
  //         />
  //       </div>
  //     </div>
  //   </>
  // );
};
